import { postRequest } from "../config/axiosConfig";
import { ISaveForLaterRequest } from "../interfaces";

class SaveAndContinueService {
    baseUrl: string;

    constructor() {
        this.baseUrl = "saveForLater/" + process.env.REACT_APP_WEBSITE_BRAND;
    }
    async saveAndContinue(body: ISaveForLaterRequest) {
        return await postRequest(`${this.baseUrl}`, body);
    }
}

export default SaveAndContinueService;
